import BaseComponent from '@js/BaseComponent'

/**
 * An abstract base class for a block component.
 */
class BaseBlockComponent extends BaseComponent {
    /**
     * Factory method for creating instances of a component.
     * @param {string} blockName - A Gutenberg block name
     */
    static create(blockName) {
        const selector = `.wp-block-${blockName.replace('/', '-')}`
        BaseComponent.create.call(this, selector)
    }
}

export default BaseBlockComponent
